module.exports = __webpack_public_path__ + "img/aeroland-tab-content-image-02.6f439f18.jpg";